import { useEffect, useMemo } from 'react'

import { usePage } from '@/components/providers/PageProvider'
import { galleryActions } from '@/store/gallery'
import { useReduxDispatch } from '@/store/hooks'
import { getGalleryKey } from '@/utils/galleryUtil'

export const useGalleryKey = () => {
  const { page } = usePage()
  const route = page?.route
  const dispatch = useReduxDispatch()
  const key = useMemo(() => getGalleryKey(route), [route])

  useEffect(() => {
    dispatch(galleryActions.setKey(key))
  }, [dispatch, key])

  return key
}
